import React, { useCallback } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Dices } from 'lucide-react';
import GameCatalog from '../components/GameCatalog';
import PageSlider from '../components/PageSlider';
import TopWinsStrip from '../components/TopWinsStrip';
import GameModal from '../components/GameModal';
import GameChoiceModal from '../components/GameChoiceModal';
import AuthModal from '../components/AuthModal';
import { useGameLauncher } from '../hooks/useGameLauncher';
import { useGameCatalog } from '../hooks/useGameCatalog';
import { SLOT_TABS as chips, SLOT_TAB_PARAM, slotTabFrom } from '../lib/slotTabs';

const Slots = () => {
  const g = useGameLauncher();
  // Sekme adresten okunur (`?filtre=`): Betrun'un sol menüsündeki alt
  // maddeler doğrudan bir sekmeye bağlanır. Sağlayıcı süzgeci de adreste
  // durduğu için diğer parametreler korunur.
  const location = useLocation();
  const [, setSearchParams] = useSearchParams();
  const tab = slotTabFrom(location.search);
  const setTab = useCallback((id) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (id === 'all') params.delete(SLOT_TAB_PARAM);
      else params.set(SLOT_TAB_PARAM, id);
      return params;
    }, { replace: true });
  }, [setSearchParams]);
  const catalog = useGameCatalog('slot', { flag: tab });

  return (
    <div className="pusu-body-gradient">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Banner Yönetimi → konum "Slot Sayfası"; tanımlı banner yoksa
            bileşen hiçbir şey çizmez. */}
        <PageSlider placement="slot" />

        <div className="catalog-heading flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: 'rgba(var(--pusu-gold-rgb),0.12)' }}>
            <Dices size={22} className="text-[var(--pusu-gold)]" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-black gold-text">Slot Oyunları</h1>
            <p className="text-sm text-gray-400">Yüzlerce farklı slot oyunu ile büyük kazançları keşfedin</p>
          </div>
        </div>

        <GameCatalog
          catalog={{ ...catalog, onPlay: g.play }}
          chips={chips}
          chipValue={tab}
          onChipChange={setTab}
          searchPlaceholder="Oyun ara..."
          emptyText="Bu filtrelerle oyun bulunamadı."
        />

        <TopWinsStrip category="slot" />
      </div>

      <GameChoiceModal
        game={g.choice} user={g.user} balance={g.balance} bonusBalance={g.bonusBalance}
        demoAvailable={g.demoAvailable}
        onClose={g.closeChoice} onReal={g.startReal} onDemo={g.startDemo}
        onLogin={() => g.openAuth('login')} onRegister={() => g.openAuth('register')}
      />
      {g.activeGame && (
        <GameModal key={`${g.activeGame.id}-${g.mode}`} game={g.activeGame}
                   mode={g.mode} onClose={g.closeGame} />
      )}
      <AuthModal open={!!g.authTab} onClose={() => g.setAuthTab(null)} defaultTab={g.authTab || 'login'} />
    </div>
  );
};

export default Slots;
